import { BrowserDictionaryItem } from '@/models/dictionary/browser';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import type { IBrowserDictionaryApi } from '@/types/proxy';

export const useBrowserDictionary = defineStore('browserDictionary', () => {
    const items = shallowRef<BrowserDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    function setData(data: IBrowserDictionaryApi[]) {
        console.time('set-browser-dictionary');
        items.value = data.map((item) => new BrowserDictionaryItem(item));
        console.timeEnd('set-browser-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
